/**
 * Cross-tree control for the first-paint boot frame (StudioBootFrame).
 *
 * AuthGate claims the frame while auth → user → shell chunk are pending and
 * dismisses it once the real shell has mounted (or when it has to show
 * sign-in / finish-account instead). The last state is also kept on `window`
 * so a listener that mounts after the event still sees it.
 */

export const PAINT_BOOT_CLAIM = "ys-paint-boot-claim";
export const PAINT_BOOT_DISMISS = "ys-paint-boot-dismiss";

export type PaintBootState = "claimed" | "dismissed";

type BootWindow = Window & { __ysPaintBootState?: PaintBootState };

export function readPaintBootState(): PaintBootState | null {
  if (typeof window === "undefined") return null;
  return (window as BootWindow).__ysPaintBootState ?? null;
}

export function claimPaintBoot(): void {
  if (typeof window === "undefined") return;
  (window as BootWindow).__ysPaintBootState = "claimed";
  window.dispatchEvent(new Event(PAINT_BOOT_CLAIM));
}

export function dismissPaintBoot(): void {
  if (typeof window === "undefined") return;
  (window as BootWindow).__ysPaintBootState = "dismissed";
  window.dispatchEvent(new Event(PAINT_BOOT_DISMISS));
}
